import { render, staticRenderFns } from "./IncidentsList.vue?vue&type=template&id=3d2fd5bc&"
import script from "./IncidentsList.vue?vue&type=script&lang=js&"
export * from "./IncidentsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports